import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, SelectItem } from 'primeng/components/common/api';
import { Company } from '../../../models/company.model';
import { User, UserApplication, UserCompany } from '../../../models/user.model';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { DateService } from '../../../services/application/date.service';
import { CompaniesService } from '../../../services/company/companies.service';
import { UsersService } from '../../../services/user/users.service';


@Component({
  selector: 'app-user-companies',
  templateUrl: './userCompanies.component.html'
})

export class UserCompaniesComponent implements OnChanges, OnInit {

  @Output() onBackPressed: EventEmitter<any> = new EventEmitter<any>();
  @Output() userCompaniesChanged: EventEmitter<User> =   new EventEmitter();

  @Input() selectedCompanies: UserCompany[];
  @Input() activeUser: User;
  selectedCompany: Company = null;
  dialogApplications = false;
  selectedApplications: UserApplication[] = [];
  companies: SelectItem[];
  selectedCompaniesClone = [];
  minDate: Date;
  maxDate: Date;
  customButtons: DataTableCustomButton[];
  newDataAvailable = false;
  showDialog = false;
  selectedRow = {};
  dialogTitlesList: any = {};
  dialogTitle: string;

  constructor (
    public srvUsers: UsersService,
    private srvTranslate: TranslateService,
    private srvCompany: CompaniesService,
    private srvUser: UsersService,
    private srvNotify: MessageService,
    private srvDate: DateService,
    private translate: TranslateService,
    public srvCalTranslate: CalendarTranslateService,
  ) {
   }

  ngOnInit(): void {
    this.companies = [{
      value: null,
      label: ''
    }];

    this.translate.get([
      'users.add_company_title',
      'users.edit_company_title'
    ])
    .subscribe(res => {
      this.dialogTitlesList.add_title = res['users.add_company_title' ];
      this.dialogTitlesList.edit_title = res['users.edit_company_title' ];
    });

    this.srvCompany.getAll().subscribe((data) => {
      data.forEach( (c) => {
        this.companies.push({ value: c.id, label: c.name });
      });
    });
  }

  ngOnChanges(changes) {
    if (changes.selectedCompanies) {
      this.selectedCompaniesClone = [];
      changes.selectedCompanies.currentValue.forEach((c) => {
        let clone = Object.assign({}, c);

        clone.date_start = new Date(clone.date_start);
        clone.date_end = new Date(clone.date_end);
        this.selectedCompaniesClone.push(clone);
      }, this);
    }
  }

  openDialog (row) {
    if (row) {
      this.selectedRow = row;
      this.dialogTitle = this.dialogTitlesList.edit_title;
    } else {
      this.selectedRow = {};
      this.dialogTitle = this.dialogTitlesList.add_title;
     }
    this.showDialog = true;
  }

  deleteElement($event) {
    this.srvUser.deleteUserCompany($event.id).subscribe().add(() => {
      this.selectedCompaniesClone.splice(this.selectedCompaniesClone.indexOf($event), 1);
      this.newDataAvailable = true;
      this.userCompaniesChanged.emit(this.activeUser);
    });
  }


  onCustomButton() {
    this.onBackPressed.emit(true);
  }

  companiesApplication (row) {
    this.srvUser.getApplicationsForUserCompany(this.activeUser.id, row.company_id).subscribe().add(() => {
      this.selectedCompany = {
        id: row.company_id,
        name: row.name,
        host_code: row.host_code
      };
      this.selectedApplications = this.srvUser.userApplications;
      this.dialogApplications = true;
    });
  }

  /*onCustomInlineButton($event) {
    switch ($event.callbackName) {
      case 'application':
        this.dialogApplications = true;

        this.srvUser.getApplicationsForUserCompany(this.activeUser.id, $event.item.company_id).subscribe().add(() => {
          this.selectedCompany = {
            id: $event.item.company_id,
            name: $event.item.name,
            host_code: ''
          };
          this.selectedApplications = this.srvUser.userApplications;
        });

        break;
    }
  }*/

  closeDialog () {
    this.showDialog = false;
  }

  userCampainesAdded (row) {
    let uc: UserCompany = {
      id: null,
      user_id: this.activeUser.id,
      name: null,
      company_id: row.company_id,
      date_start: row.date_start,
      date_end: row.date_end
    };

    this.srvUser.createUserCompany(uc).subscribe(
      () => this.newDataAvailable = true,
      error => console.error(error),
      () => {
        this.userCompaniesChanged.emit(this.activeUser);
        this.closeDialog ();
      }
    );
  }

  userCampainesUpdateed (row) {
    let uc: UserCompany = {
      id: row.id,
      user_id: this.activeUser.id,
      name: null,
      company_id: row.company_id,
      date_start: row.date_start,
      date_end: row.date_end
    };
    this.srvUser.updateUserCompany(uc).subscribe(
      () => this.newDataAvailable = true,
      error => console.error(error),
      () => {
        this.userCompaniesChanged.emit(this.activeUser);
        this.closeDialog ();
      }
    );
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/users/userCompanies.component.ts